'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OmalomaController = function () {
  function OmalomaController($rootScope, omalomaService, localizationService) {
    var _this = this;

    _classCallCheck(this, OmalomaController);

    this.omalomaService = omalomaService;

    this.$rootScope = $rootScope;

    this.localizationService = localizationService;

    this.winresConnectionOK = "loading";

    this.$rootScope.winresConnectionName = null;

    this.isLoggedInAsCustomer = true;

    this.$rootScope.winresConnectionOK = true;
    // Default values, shown before real values are loaded.
    this.logo = 'https://via.placeholder.com/720x200/24aaff/000000?text=Omaloma-logo+tähän';
    this.office = {
      Name: ' ',
      StreetAddress: ' ',
      PostalAddress: ' ',
      PhoneNumber: ' ',
      EmailAddress: ' ' };

    // this.ui = {
    //   HeaderImage: 'https://omalomat.fi/wp-content/uploads/2018/04/bg-5-1600x600.jpg'
    // }

    // Default header image.
    this.ui = {
      HeaderImage: ''
    };

    console.log("Omaloma ctrl Getting login status");
    this.getLoginStatus();
    console.log("omaloma ctrl init: isLoggedInAsCustomer: ", this.isLoggedInAsCustomer);
    this.$rootScope.$on('omaloma-refresh', function () {
      return _this.getLoginStatus();
    });
  }

  _createClass(OmalomaController, [{
    key: 'setLanguage',
    value: function setLanguage(code) {
      this.localizationService.setLanguage(code);
    }
  }, {
    key: 'setConnectionName',
    value: function setConnectionName(connectionName) {
      var _this2 = this;

      console.log('[Omaloma] Setting connection name to', connectionName);
      this.$rootScope.winresConnectionName = connectionName;
      this.omalomaService.getOfficeSiteParameters(connectionName).then(function (params) {
        _this2.updateUI(params.UI);
        _this2.updateOffice(params.Office);
        _this2.setConnectionStatus(true);
      }).catch(function (error) {
        console.error('[Omaloma] Failed to get parameters:', error);
        if (error) {
          console.error("Connection Name not ok");
          _this2.setConnectionStatus(false);
        }
      });
    }
  }, {
    key: 'updateUI',
    value: function updateUI(ui) {
      this.ui = ui;
      console.log('Logo URL is: ' + ui.Logo);
    }
  }, {
    key: 'updateOffice',
    value: function updateOffice(office) {
      this.office = office;
    }
  }, {
    key: 'setConnectionStatus',
    value: function setConnectionStatus(status) {
      console.log("Setting winresConnectionOK to: ", status);
      this.winresConnectionOK = status;
      //this.$rootScope.winresConnectionOK = false;
    }
  }, {
    key: 'getLoginStatus',
    value: function getLoginStatus() {
      console.log("Omaloma ctrl running getLoginStatus...");
      if (this.omalomaService.isLoggedInAsCustomer()) {
        this.isLoggedInAsCustomer = true;
      } else {
        this.isLoggedInAsCustomer = false;
      }
      console.log("omaloma getloginstatus isLoggedInAsCustomer: ", this.isLoggedInAsCustomer);
    }
  }]);

  return OmalomaController;
}();

OmalomaController.$inject = ['$rootScope', 'omalomaService', 'localizationService'];

_module3.default.controller('Omaloma', OmalomaController);


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/controllers/omaloma.js
// module id = 508
// module chunks = 2